import React, { Component, useEffect, useState } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import SideBar from '../sidebar/sidebar'
import { Link } from 'react-router-dom';
import Axios from 'axios';
import ReactHtmlParser from 'react-html-parser'
import { BASE } from '../api/api';
import { render } from 'react-dom';

class Bioethics extends Component{

    constructor(props){
        super()
        this.state ={
            bio: [],
            details:''
        }
    }
    componentDidMount(){
        Axios.get(BASE + 'jsonapi/node/page?filter[title]=Islamic Bioethics Project')
            .then((res) => {
                this.setState({
                    bio:res.data.data
                })
                this.changeDet(res.data.data[0].attributes.body.value)
            })
    }
    changeDet(data){
        const myStr = data.replace(/<a /g,`<a target='_blank' class='left-margin' `);
        console.log('myStr',myStr)
        this.setState({
            details: myStr
        })
    }
    render(){
        return (
            <div>
            <Header />
            <div className='container side-arrange' style={{ minHeight: '71.6vh' }}>
                <SideBar data={'data2'} />
                <div className='columns'>
                    <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/bioethics'>Islamic Bioethics Project</Link></div>
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="">
                                <h1 className="heading">{this.state.bio.length ? this.state.bio[0].attributes ? this.state.bio[0].attributes.title : '' : ""}</h1>
                            </div>
                        </div>
                    </div>
                    <div className="main-content listing">
                        <div id="" className="content-p ">
                            <div className="row">
                                <div className="region region-content">
                                    <div className="listings">
                                        {this.state.bio.length ? this.state.bio[0].attributes ? this.state.bio[0].attributes.body ? ReactHtmlParser(this.state.details) : '' : "" : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="main-content listing">
                    <div className="container ">
                    <div className="row">
                    <div className="region region-content">
                    <div className="listings">
                    
                    </div>
                    </div>
                    </div>
                    </div>
                </div> */}
                </div>
            </div>
            <div className='construct-footer'>
                <Footer />
            </div>

        </div>
    )
}
}export default Bioethics;